import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import Icon from '~/components/Icon/Icon';
import { ModalType } from '~/components/Modal/interface';
import { useModal } from '~/hooks/useModal';

import { mainStore } from '~/stores';

import styles from './ExpressBanner.module.scss';

const ExpressBanner = () => {
  const { t } = useTranslation();
  const { openModal } = useModal();

  const open = () => {
    openModal(ModalType.DeliveryInfo, 'home');
  };

  const handleClose = () => {
    mainStore.setIsExpressDeliveryBannerClosed(true);
  };

  if (!mainStore.isDeliveryBannerShown) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <p className={styles.text}>
          <span>{t('phrases:needDrinks')}.</span> {t('phrases:chooseDelivery')}
        </p>
        <span
          className={styles.readMore}
          role="button"
          tabIndex={-1}
          onClick={open}
        >
          {t('readMore')}
        </span>
      </div>
      <div
        className={styles.closeWr}
        role="button"
        tabIndex={-1}
        onClick={handleClose}
      >
        <Icon type="close" size={24} />
      </div>
    </div>
  );
};

export default observer(ExpressBanner);
